import React, { useEffect, useMemo, useState } from "react";
import axios from "axios";
import { API_ROOT } from "../service/Services";
import Spinner from "../components/Spinner";
import {
  FaFolderOpen,
  FaTimesCircle,
  FaPlusCircle,
  FaSpinner,
  FaBell,
} from "react-icons/fa";

export default function Leads() {
  const [loading, setLoading] = useState(false);
  const [leads, setLeads] = useState([]);
  const [toast, setToast] = useState({
    message: "",
    visible: false,
    type: "success",
  });
  const [leadSuggestions, setLeadSuggestions] = useState([]); // ✅ store unique TypeOfLead

  const [newLead, setNewLead] = useState({
    date: new Date().toISOString().split("T")[0],
    typeOfLead: "",
    companyName: "",
    contactName: "",
    contactEmail: "",
    contactPhone: "",
    designation: "",
    status: "New",
    remark: "",
  });

  const authHeaders = useMemo(
    () => ({
      headers: { authorization: `Bearer ${localStorage.getItem("token")}` },
    }),
    []
  );

  const loadInit = async () => {
    try {
      setLoading(true);
      const res = await axios.get(`${API_ROOT}/leads`, authHeaders);
      const fetchedLeads = res.data?.leads || [];
      setLeads(fetchedLeads);

      // ✅ Extract unique typeOfLead for suggestions
      const uniqueTypes = [
        ...new Set(fetchedLeads.map((lead) => lead.typeOfLead).filter(Boolean)),
      ];
      setLeadSuggestions(uniqueTypes);
    } catch (e) {
      console.error(e);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    loadInit();
  }, []);


  const validateLead = () => {
  if (!newLead.contactName.trim()) {
    setToast({
      message: "Contact Name is required",
      visible: true,
      type: "error",
    });
    return false;
  }
  return true;
};

  // ✅ Validation
  // const validateLead = () => {
  //   if (!newLead.companyName.trim()) {
  //     setToast({
  //       message: "Company Name is required",
  //       visible: true,
  //       type: "error",
  //     });
  //     return false;
  //   }
  //   if (!newLead.contactName.trim()) {
  //     setToast({
  //       message: "Contact Name is required",
  //       visible: true,
  //       type: "error",
  //     });
  //     return false;
  //   }
  //   if (!newLead.contactEmail.trim()) {
  //     setToast({
  //       message: "Email is required",
  //       visible: true,
  //       type: "error",
  //     });
  //     return false;
  //   }
  //   const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
  //   if (!emailRegex.test(newLead.contactEmail)) {
  //     setToast({
  //       message: "Invalid Email format",
  //       visible: true,
  //       type: "error",
  //     });
  //     return false;
  //   }
  //   if (!newLead.contactPhone.trim()) {
  //     setToast({
  //       message: "Phone Number is required",
  //       visible: true,
  //       type: "error",
  //     });
  //     return false;
  //   }
  //   const phoneRegex = /^\d{10}$/;
  //   if (!phoneRegex.test(newLead.contactPhone)) {
  //     setToast({
  //       message: "Phone Number must be 10 digits",
  //       visible: true,
  //       type: "error",
  //     });
  //     return false;
  //   }
  //   return true;
  // };

  const createLead = async () => {
    if (!validateLead()) return;

    try {
      setLoading(true);

      const leadToSend = {
        ...newLead,
        typeOfLead: newLead.typeOfLead || "",
      };
      const res = await axios.post(
        `${API_ROOT}/leads`,
        leadToSend,
        authHeaders
      );

      const savedLead = res.data?.lead || res.data?.data;
      setLeads((prev) => [...prev, savedLead]);

      // ✅ Update suggestions dynamically
      if (
        savedLead?.typeOfLead &&
        !leadSuggestions.includes(savedLead.typeOfLead)
      ) {
        setLeadSuggestions((prev) => [...prev, savedLead.typeOfLead]);
      }

      // Reset form
      setNewLead({
        date: new Date().toISOString().split("T")[0],
        typeOfLead: "",
        companyName: "",
        contactName: "",
        contactEmail: "",
        contactPhone: "",
        designation: "",
        status: "New",
        remark: "",
      });

      setToast({
        message: "Lead generated successfully!",
        visible: true,
        type: "success",
      });
      setTimeout(() => setToast({ message: "", visible: false }), 3000);
    } catch (e) {
      console.error(e);
      setToast({
        message: "Something went wrong!",
        visible: true,
        type: "error",
      });
      setTimeout(() => setToast({ message: "", visible: false }), 3000);
    } finally {
      setLoading(false);
    }
  };

  // ✅ Count leads per status
  const statusCounts = useMemo(() => {
    const counts = {
      Open: 0,
      Closed: 0,
      New: 0,
      "In Progress": 0,
      Reminder: 0,
    };
    leads.forEach((lead) => {
      if (counts[lead.status] !== undefined) {
        counts[lead.status] += 1;
      }
    });
    return counts;
  }, [leads]);

  return (
    <div className="flex flex-col gap-6 w-full">
      {loading && <Spinner />}

      {/* Toast notification */}
      {toast.visible && (
        <div
          className={`fixed top-4 right-4 px-4 py-2 rounded shadow-lg z-50 text-white ${
            toast.type === "success" ? "bg-green-500" : "bg-red-500"
          }`}
        >
          {toast.message}
        </div>
      )}

      {/* Status Summary */}

      {/* Create Lead Form */}
      <div className="card p-6 shadow-lg rounded-xl bg-gradient-to-br from-white via-gray-100 to-white border border-gray-200">
        <h3 className="text-2xl font-semibold mb-6 text-gray-800">
          Create New Lead
        </h3>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
          {/* Date */}
          <div>
            <label className="block text-sm font-medium mb-2 text-gray-700">
              Date
            </label>
            <input
              type="date"
              value={newLead.date}
              onChange={(e) =>
                setNewLead({ ...newLead, date: e.target.value })
              }
              className="border border-gray-300 rounded-lg p-3 text-sm w-full focus:ring-2 focus:ring-blue-400 focus:border-blue-500 transition-all duration-200 outline-none shadow-sm hover:shadow-md"
            />
          </div>

          {/* Type of Lead with Suggestions */}
          <div>
            <label className="block text-sm font-medium mb-2 text-gray-700">
              Type of Lead
            </label>
            <input
              type="text"
              list="lead-options"
              value={newLead.typeOfLead}
              onChange={(e) =>
                setNewLead({ ...newLead, typeOfLead: e.target.value })
              }
              placeholder="Enter type of lead..."
              className="border border-gray-300 rounded-lg p-3 text-sm w-full 
               focus:ring-2 focus:ring-blue-400 focus:border-blue-500 
               transition-all duration-200 outline-none shadow-sm hover:shadow-md"
            />
            {/* Suggestions */}
            <datalist id="lead-options">
              {leadSuggestions.map((lead, index) => (
                <option key={index} value={lead} />
              ))}
            </datalist>
          </div>

          {/* Company Name */}
          <div>
            <label className="block text-sm font-medium mb-2 text-gray-700">
              Company Name
            </label>
            <input
              type="text"
              value={newLead.companyName}
              onChange={(e) =>
                setNewLead({ ...newLead, companyName: e.target.value })
              }
              className="border border-gray-300 rounded-lg p-3 text-sm w-full focus:ring-2 focus:ring-blue-400 focus:border-blue-500 transition-all duration-200 outline-none shadow-sm hover:shadow-md"
            />
          </div>

          {/* Contact Name */}
          <div>
            <label className="block text-sm font-medium mb-2 text-gray-700">
              Contact Name
            </label>
            <input
              type="text"
              value={newLead.contactName}
              onChange={(e) =>
                setNewLead({ ...newLead, contactName: e.target.value })
              }
              className="border border-gray-300 rounded-lg p-3 text-sm w-full focus:ring-2 focus:ring-blue-400 focus:border-blue-500 transition-all duration-200 outline-none shadow-sm hover:shadow-md"
            />
          </div>

          {/* Contact Email */}
          <div>
            <label className="block text-sm font-medium mb-2 text-gray-700">
              Email
            </label>
            <input
              type="email"
              value={newLead.contactEmail}
              onChange={(e) =>
                setNewLead({ ...newLead, contactEmail: e.target.value })
              }
              className="border border-gray-300 rounded-lg p-3 text-sm w-full focus:ring-2 focus:ring-blue-400 focus:border-blue-500 transition-all duration-200 outline-none shadow-sm hover:shadow-md"
            />
          </div>

          {/* Contact Phone */}
          <div>
            <label className="block text-sm font-medium mb-2 text-gray-700">
              Phone
            </label>
            <input
              type="text"
              value={newLead.contactPhone}
              onChange={(e) =>
                setNewLead({ ...newLead, contactPhone: e.target.value })
              }
              className="border border-gray-300 rounded-lg p-3 text-sm w-full focus:ring-2 focus:ring-blue-400 focus:border-blue-500 transition-all duration-200 outline-none shadow-sm hover:shadow-md"
            />
          </div>

          {/* Designation */}
          <div>
            <label className="block text-sm font-medium mb-2 text-gray-700">
              Designation
            </label>
            <input
              type="text"
              value={newLead.designation}
              onChange={(e) =>
                setNewLead({ ...newLead, designation: e.target.value })
              }
              className="border border-gray-300 rounded-lg p-3 text-sm w-full focus:ring-2 focus:ring-blue-400 focus:border-blue-500 transition-all duration-200 outline-none shadow-sm hover:shadow-md"
            />
          </div>

          {/* Status */}
          <div>
            <label className="block text-sm font-medium mb-2 text-gray-700">
              Status
            </label>
            <select
              value={newLead.status}
              onChange={(e) =>
                setNewLead({ ...newLead, status: e.target.value })
              }
              className="border border-gray-300 rounded-lg p-3 text-sm w-full focus:ring-2 focus:ring-blue-400 focus:border-blue-500 transition-all duration-200 outline-none shadow-sm hover:shadow-md"
            >
               <option value="New">New</option>
              {/* <option value="Open">Open</option>
              <option value="Closed">Closed</option>
              <option value="In Progress">In Progress</option>
              <option value="Reminder">Reminder</option> */}
            </select>
          </div>

          {/* Remark */}
          <div className="col-span-1 md:col-span-2">
            <label className="block text-sm font-medium mb-2 text-gray-700">
              Remark
            </label>
            <textarea
              value={newLead.remark}
              onChange={(e) =>
                setNewLead({ ...newLead, remark: e.target.value })
              }
              className="border border-gray-300 rounded-lg p-3 text-sm w-full focus:ring-2 focus:ring-blue-400 focus:border-blue-500 transition-all duration-200 outline-none shadow-sm hover:shadow-md resize-none"
              rows={4}
            />
          </div>
        </div>

        {/* Save Button */}
        <div className="flex justify-end mt-6">
          <button
            onClick={createLead}
            disabled={loading}
            className="px-6 py-3 bg-gradient-to-r from-blue-600 to-blue-500 text-white font-medium rounded-lg shadow-md hover:shadow-lg transform hover:-translate-y-0.5 transition-all duration-300 disabled:opacity-50 disabled:cursor-not-allowed"
          >
            {loading ? "Saving..." : "Save Lead"}
          </button>
        </div>
      </div>
    </div>
  );
}
